import UltMeta, { Meta } from "@/meta/UltMeta/index";

// 货源匹配

// 操作入口
class goodsPlatform extends UltMeta {
    SHIP_PC = new Meta(1, "船务PC");
    SHIP_APP_CARGO = new Meta(2, "船务移动端货主身份");
    MOBILE_CAPTION = new Meta(3, "船务移动端船主身份");
}
export const GOODS_PLATFORM = new goodsPlatform();

// 匹配货源结果数
class matchResultCount extends UltMeta {
    ZERO = new Meta(0, "0");
    ONE = new Meta(1, "1");
    TWO = new Meta(2, "2");
    THREE = new Meta(3, "3");
    FOUR = new Meta(4, "4");
    FIVE = new Meta(5, "5");
    SIX = new Meta(6, "6");
    SEVEN = new Meta(7, "7");
    EIGHT = new Meta(8, "8");
    NINE = new Meta(9, "9");
    TEN = new Meta(10, "10");
}
export const MATCH_RESULT_COUNT = new matchResultCount();

// 匹配度
class matchScore extends UltMeta {
    SCORE_100 = new Meta(1, "100%");
    SCORE_80 = new Meta(2, "80～90%");
    SCORE_60 = new Meta(3, "60～70%");
    NO_MATCH_NUM = new Meta(4, "50%及以下");
}
export const MATCH_SCORE = new matchScore();

class matchScoreDetail extends UltMeta {
    SCORE_100 = new Meta(1, "100%");
    SCORE_80 = new Meta(2, "80～90%");
    SCORE_60 = new Meta(3, "60～70%");
    NO_MATCH = new Meta(4, "50%及以下");
}
export const MATCH_SCORE_DETAIL = new matchScoreDetail();

// 是否有进入
class isEnter extends UltMeta {
    YES = new Meta(1, "是");
    NO = new Meta(0, "否");
}
export const IS_ENTER = new isEnter();

// 详情排序规则
class detailSortRule extends UltMeta {
    DEFAULT = new Meta(1, "默认排序");
    MATCH_SCORE = new Meta(2, "匹配度排序");
}
export const DETAIL_SORT_RULE = new detailSortRule();

// 船舶匹配

// 操作入口
class shipPlatform extends UltMeta {
    SHIP_PC = new Meta(1, "船务PC");
    ADMIN_SYSTEM = new Meta(2, "管理后台");
}
export const SHIP_PLATFORM = new shipPlatform();

// 功能模块
class functionModule extends UltMeta {
    REQUIRE_SEARCH_SHIP = new Meta(1, "按需求查船");
    SMART_MATCH_SHIP = new Meta(2, "智能匹配船舶");
}
export const FUNCTION_MODULE = new functionModule();

// 数据来源
class dataSource extends UltMeta {
    EMPTY_SHIP_INFO = new Meta(1, "空船信息");
    SMART_RECOMMENDATION = new Meta(2, "智能推荐");
}
export const DATA_SOURCE = new dataSource();

// 匹配分数
class matchScoreShip extends UltMeta {
    LEVEL1 = new Meta(1, "90-100分");
    LEVEL2 = new Meta(2, "80-89分");
    LEVEL3 = new Meta(3, "70-79分");
    LEVEL4 = new Meta(4, "60-69分");
}
export const MATCH_SCORE_SHIP = new matchScoreShip();

class matchScoreShipDetail extends UltMeta {
    LEVEL1 = new Meta(1, "90-100分");
    LEVEL2 = new Meta(2, "80-89分");
    LEVEL3 = new Meta(3, "70-79分");
    LEVEL4 = new Meta(4, "60-69分");
    LEVEL5 = new Meta(5, "低于60分");
}
export const MATCH_SCORE_SHIP_DETAIL = new matchScoreShipDetail();

// 取消原因 用船需求取消/填写信息有误/服务体验不佳/费用不合适（定金、信息服务费）/已通过其他渠道找到船/等待时间太长）
class cancelReason extends UltMeta {
    REASON1 = new Meta(10, "用船需求取消");
    REASON2 = new Meta(7, "填写信息有误");
    REASON3 = new Meta(13, "服务体验不佳");
    REASON4 = new Meta(11, "费用不合适（定金、信息服务费）");
    REASON5 = new Meta(12, "已通过其他渠道找到船");
    REASON6 = new Meta(9, "等待时间太长");
}
export const CANCEL_REASON = new cancelReason();

// 关闭类型
class closeType extends UltMeta {
    END = new Meta(2, "平台结束需求");
    CLOSE = new Meta(3, "平台关闭需求");
}
export const CLONSE_TYPE = new closeType();

// 取消类型
class cancelType extends UltMeta {
    OWNER_CANCEL = new Meta(1, "货主取消需求");
    PLATFORM_CANCEL = new Meta(2, "平台取消需求");
}
export const CANCEL_TYPE = new cancelType();

class sortType extends UltMeta {
    LEVEL1 = new Meta(1, "默认排序");
    LEVEL2 = new Meta(2, "匹配分数排序");
}
export const MATCH_SCORE_TYPE = new sortType();
